import React from 'react';
import { KeyValueItem } from '@gerdau/hefesto-mais-web';
import moment from 'moment';
import { Skeleton } from '@gerdau/hefesto/Skeleton';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { ICustomer } from '../../../../../store/ducks/customers/types';
import { IFabricationContract } from '../../../../../store/ducks/fabrication-contracts/types';
import { IFabricationOrder } from '../../../../../store/ducks/fabrication-orders/types';
import { uppercaseOnlyFirstLetter } from '../../../../../utils/formatStrings';
import {
  GeneralInfoContentContainer,
  GeneralInfoContentItem,
  GeneralInfoContentItensContainer
} from './styles';
import { Title } from '@gerdau/hefesto/Title';
import { WhiteBlockContainer } from '../styles';

interface IGeneralInfoContentProps {
  fabricationOrder: IFabricationOrder;
  contract?: IFabricationContract;
}

const GeneralInfoContent: React.FC<IGeneralInfoContentProps> = ({
  fabricationOrder,
  contract
}) => {
  const customersState = useSelector(
    (appState: ApplicationState) => appState.customers
  );

  const getContractCustomer = (): ICustomer | undefined => {
    if (!contract || customersState.loading) {
      return;
    }
    const customer = customersState.customers.find(
      (cust) => cust.customerId === contract?.soldTo.code
    );
    return customer;
  };

  return (
    <WhiteBlockContainer>
      <Title level={2}>Dados gerais do pedido</Title>

      <GeneralInfoContentContainer>
        <KeyValueItem title={'Tipo de produto'}>
          {fabricationOrder.productType || '-'}
        </KeyValueItem>

        <GeneralInfoContentItensContainer>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Nº do pedido'}>
              {fabricationOrder.orderNumber}
            </KeyValueItem>
          </GeneralInfoContentItem>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Contrato'}>
              {fabricationOrder.contractNumber}
            </KeyValueItem>
          </GeneralInfoContentItem>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Obra'}>
              {contract ? (
                <span className="description">{contract.customerOrder}</span>
              ) : (
                <Skeleton type="title" />
              )}
            </KeyValueItem>
          </GeneralInfoContentItem>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Torre ou bloco'}>
              {fabricationOrder.tower || '-'}
            </KeyValueItem>
          </GeneralInfoContentItem>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Data desejada'}>
              {fabricationOrder.desiredDate
                ? moment(fabricationOrder.desiredDate, 'YYYY-MM-DD').format(
                    'DD/MM/YYYY'
                  )
                : '-'}
            </KeyValueItem>
          </GeneralInfoContentItem>
        </GeneralInfoContentItensContainer>

        <GeneralInfoContentItensContainer>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Veículo'}>
              {fabricationOrder.vehicleTypes?.length > 0 ? (
                fabricationOrder.vehicleTypes.map((vehicleType, idx) => (
                  <span key={idx} className="vehicle-description">
                    {vehicleType.description}
                  </span>
                ))
              ) : (
                <>-</>
              )}
            </KeyValueItem>
          </GeneralInfoContentItem>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Tipo de descarga'}>
              {contract ? (
                contract.logistic?.dischargeType || '-'
              ) : (
                <Skeleton type="title" />
              )}
            </KeyValueItem>
          </GeneralInfoContentItem>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Cliente'}>
              {contract && !customersState.loading ? (
                uppercaseOnlyFirstLetter(getContractCustomer()?.name || '-')
              ) : (
                <Skeleton type="title" />
              )}
            </KeyValueItem>
          </GeneralInfoContentItem>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Solicitante'}>
              {fabricationOrder.solicitant ? (
                fabricationOrder.solicitant?.name || '-'
              ) : (
                <Skeleton type="title" />
              )}
            </KeyValueItem>
          </GeneralInfoContentItem>
          <GeneralInfoContentItem>
            <KeyValueItem title={'Telefone/Email'}>
              {fabricationOrder.solicitant ? (
                (fabricationOrder.solicitant.phoneNumber ?? ' ') +
                (fabricationOrder.solicitant.phoneNumber != null ? ' / ' : '') +
                (fabricationOrder.solicitant.email ?? ' ')
              ) : (
                <Skeleton type="title" />
              )}
            </KeyValueItem>
          </GeneralInfoContentItem>
        </GeneralInfoContentItensContainer>
      </GeneralInfoContentContainer>
    </WhiteBlockContainer>
  );
};

export default GeneralInfoContent;
